/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityReportDetailsResource } from './';
import {
    ActivityReportDetailsResourceFromJSON,
    ActivityReportDetailsResourceFromJSONTyped,
    ActivityReportDetailsResourceToJSON,
} from './';
import type { ProjectDetailsResource } from './';
import {
    ProjectDetailsResourceFromJSON,
    ProjectDetailsResourceFromJSONTyped,
    ProjectDetailsResourceToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsProjectDetailsResource
 */
export interface TimeAndMaterialsProjectDetailsResource extends ProjectDetailsResource {
    /**
     * 
     * @type {WorkedUnit}
     * @memberof TimeAndMaterialsProjectDetailsResource
     */
    workedUnit: WorkedUnit;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsProjectDetailsResource
     */
    workedRate: number;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsProjectDetailsResource
     */
    estimatedTotalWorkedAmount?: number;
    /**
     * 
     * @type {ActivityReportDetailsResource}
     * @memberof TimeAndMaterialsProjectDetailsResource
     */
    activityReport: ActivityReportDetailsResource;
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsProjectDetailsResource
     */
    oldestUnpaidLotYearMonth?: string;
}

/**
 * Check if a given object implements the TimeAndMaterialsProjectDetailsResource interface.
 */
export function instanceOfTimeAndMaterialsProjectDetailsResource(value: object): value is TimeAndMaterialsProjectDetailsResource {
    if (!('workedUnit' in value) || value['workedUnit'] === undefined) return false;
    if (!('workedRate' in value) || value['workedRate'] === undefined) return false;
    if (!('activityReport' in value) || value['activityReport'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsProjectDetailsResourceFromJSON(json: any): TimeAndMaterialsProjectDetailsResource {
    return TimeAndMaterialsProjectDetailsResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsProjectDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsProjectDetailsResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsResourceFromJSONTyped(json, ignoreDiscriminator),
        'workedUnit': WorkedUnitFromJSON(json['workedUnit']),
        'workedRate': json['workedRate'],
        'estimatedTotalWorkedAmount': json['estimatedTotalWorkedAmount'] == null ? undefined : json['estimatedTotalWorkedAmount'],
        'activityReport': ActivityReportDetailsResourceFromJSON(json['activityReport']),
        'oldestUnpaidLotYearMonth': json['oldestUnpaidLotYearMonth'] == null ? undefined : json['oldestUnpaidLotYearMonth'],
    };
}

export function TimeAndMaterialsProjectDetailsResourceToJSON(value?: TimeAndMaterialsProjectDetailsResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsResourceToJSON(value, true),
        'workedUnit': WorkedUnitToJSON(value['workedUnit']),
        'workedRate': value['workedRate'],
        'estimatedTotalWorkedAmount': value['estimatedTotalWorkedAmount'],
        'activityReport': ActivityReportDetailsResourceToJSON(value['activityReport']),
        'oldestUnpaidLotYearMonth': value['oldestUnpaidLotYearMonth'],
    };
}

